module.exports = __webpack_public_path__ + "387f8ec8109c75c8e4f5e315b8a9ba48.pdf";